import { Component, Inject, OnInit } from '@angular/core';
import { equipmentListVM } from '../../component-forecast/component-forecast.model';
import { ComponentForecastService } from '../../component-forecast/component-forecast.service';
import { CustomerContactService } from '../../customer-contact/add-new-user-cl/customer-contact.service';
import { crsfNewVM, EqLevelDataforCustomerContact, EqLevelDataforUserContact, EquipmentTabforCuatomerContact } from '../../customer-contact/Models/customer-contact.model';
import { CustomerService } from '../../GET_NEW_UI/services/customer.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-new-equipment-uc',
  templateUrl: './add-new-equipment-uc.component.html',
  styleUrls: ['./add-new-equipment-uc.component.scss']
})
export class AddNewEquipmentUcComponent implements OnInit {

  constructor(  public dialogRef:MatDialogRef<AddNewEquipmentUcComponent>,
    private _customerContactService:CustomerContactService,
    public _fleetService: ComponentForecastService,
    @Inject(MAT_DIALOG_DATA) public data:any,
    private _customerService:CustomerService) { }

    CustomerList:any
    selectedCustomer:number=1
    selectedSiteId:string;
    jobsitebyCustomerID:crsfNewVM[]
    equipmnentList: equipmentListVM[]
    EquipmentListForTab:EquipmentTabforCuatomerContact[]
    selectedOptions1:any []= [];
    selectedOptions2:any []= [];

    array1:any = [];
    array2:any = [];
    userId:number
    JobsiteList:crsfNewVM[];


  ngOnInit() {
    this.GetCustomerDetails();
    this.userId=this.data.userId;
    this.EquipmentListForTab=this.data.EquipmentListForTab
  }

  DialogClose(){
    this.dialogRef.close(false)
  

  }

  onChangeCustomer(){
    console.log("SELcet ",this.selectedCustomer)
    
    //this.GetJobsitesbyId();
    this.GetJobSiteDetails();
    
  }
  GetJobsitesbyId(){
    if(!this.selectedCustomer)
    {
      return;
    }
    this._customerService.GetJobsitebyId_(this.selectedCustomer).subscribe(res=>{
      this.jobsitebyCustomerID = res;
      console.log('This.GetJobsitebyId',res);
    })
  }

  GetJobSiteDetails(){
    
    this._customerService.getCrsfInfo_().subscribe(res=>{
      this.JobsiteList = res
  
      console.log("this.customerauto",this.JobsiteList);
      this.jobsitebyCustomerID= this.JobsiteList.filter(x=>x.customer_auto == this.selectedCustomer);
      console.log("this.jobsitebyCustomerID",this.jobsitebyCustomerID);
      

  });
  }
  
  jobsiteChanged(event:any) {
    let temparr=[]
    let value = event.value;
    this.selectedSiteId = event.value;
    this._fleetService.getEquipmentList(value).subscribe(result => {
        this.equipmnentList = result
        this.array1=result
        console.log("befire push array", this.EquipmentListForTab)
        console.log("array1", this.array1)
        this.EquipmentListForTab.map(x=>{
          let checkhasexisitng = this.array1.find(z => z.EquipmentId == x.equipmentid_auto);
          if(checkhasexisitng)
          {
             temparr.push(checkhasexisitng)
            this.array2=temparr
            this.array1 = this.array1.filter(z=>z.EquipmentId!=x.equipmentid_auto);
          }
          else
          this.array2=temparr
        })
      })
    }

  GetCustomerDetails(){
    this._customerContactService.GetCustomerDetails().subscribe(res=>{
      this.CustomerList = res;
      res.map(x=>{x.customerName
      x.customerId})
  
      console.log("this.customerlist",this.CustomerList);
  })
  }

   
  AddItem() {
    console.log("arry2", this.array2)
    console.log("selectedOptions1", this.selectedOptions1)
    if (this.selectedOptions1.length > 0) {
      this.selectedOptions1.map(x => {
        if (this.array2.length > 0) {
          let checkhasexisitng = this.array2.find(z => z.EquipmentId == x.EquipmentId);
          if (!checkhasexisitng) {
            this.array2.push(x);
            this.array1 = this.array1.filter(z=>z.EquipmentId!=x.EquipmentId);
          }
        } else {
          this.array2.push(x);
          this.array1 = this.array1.filter(z=>z.EquipmentId!=x.EquipmentId);
        }
      });
    }
  }


  RemoveItem() {
    if (this.selectedOptions2.length > 0) {
      this.selectedOptions2.map(x => {
        this.array2 = this.array2.filter(z => z.EquipmentId != x.EquipmentId);
        this.array1.push(x);
        this.selectedOptions2 = [];
      });
    }
  }








  //AddNewequipmentto user
  AddNewEquipmentstoUser()
  {
    let useridarray:any[]=[];
    
    if(this.array2.length>0)
    {
      this.array2.map(item =>{if(item.EquipmentId){
        useridarray.push(item.EquipmentId)
      }}
      )
  
    }
    
      let params = new  EqLevelDataforUserContact();
      params.customer_auto=this.selectedCustomer;
      params.user_auto=this.userId;//send as a one value
      params.EvalA=true;
      params.EvalB=true;
      params.EvalC=true;
      params.EvalX=true;
      params.crsf_auto=Number(this.selectedSiteId);
      params.equipmentid_auto=useridarray; //send as a list
      params.Type="EQ"
      
  
      
  
      console.log("this.params",params);
      this._customerService.AddNewEquipmentstoUser(params).subscribe(res=>{
        console.log("result",res);
        if(res=true)
        {
          this.DialogClose();
        }
      })
      
      
  }
  
}
